import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// ─── Hero Section ───────────────────────────────────────────────────────────
function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center bg-dark grid-bg overflow-hidden px-4 sm:px-6 lg:px-8 py-24" data-id="element-715">
      {/* Gold cloud glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" aria-hidden="true" data-id="element-716">
        <div className="w-[700px] h-[500px] rounded-full blur-3xl opacity-100" style={{
        background: 'radial-gradient(ellipse at center, rgba(176,141,87,0.18) 0%, transparent 70%)'
      }} data-id="element-717" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-718">
        {/* Eyebrow pill */}
        <div className="inline-block border border-accent/40 text-accent text-xs tracking-widest uppercase rounded-full px-4 py-1.5 mb-8 font-body" data-id="element-719">
          INCUBADORA DE CRECIMIENTO — SEGUROS DE VIDA
        </div>

        {/* Headline */}
        <h1 className="font-editorial font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-tight text-bg mb-6" data-id="element-720">
          Un negocio sin sistema no tiene{' '}
          <span className="text-accent" data-id="element-721">control</span>.{' '}
          <br className="hidden sm:block" data-id="element-722" />
          Tiene incertidumbre.
        </h1>

        {/* Subheadline */}
        <p className="font-body text-bg/70 text-lg sm:text-xl max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-723">
          Instala <strong className="text-bg font-semibold" data-id="element-724">CONTROL</strong>:
          leads propios + proceso de ventas + reclutamiento con estructura y
          acompañamiento.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14" data-id="element-725">
          <Link to="/contact-us" className="w-full sm:w-auto inline-flex items-center justify-center bg-accent hover:bg-accent-dark text-dark font-body font-semibold text-base rounded-full px-8 py-3.5 transition-colors duration-200" data-id="element-726">
            Agendar consultoría
          </Link>
          <Link to="/como-funciona" className="w-full sm:w-auto inline-flex items-center justify-center border border-bg/30 hover:border-bg/60 text-bg font-body font-medium text-base rounded-full px-8 py-3.5 transition-colors duration-200" data-id="element-727">
            Ver cómo funciona
          </Link>
        </div>

        {/* Trust bullets */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8" data-id="element-728">
          <TrustBullet text="Sin promesas de ingresos" data-id="element-729" />
          <span className="hidden sm:block w-px h-4 bg-bg/20" aria-hidden="true" data-id="element-730" />
          <TrustBullet text="Implementación desde semana 1" data-id="element-731" />
          <span className="hidden sm:block w-px h-4 bg-bg/20" aria-hidden="true" data-id="element-732" />
          <TrustBullet text="Acompañamiento y estructura" data-id="element-733" />
        </div>
      </div>
    </section>;
}
function TrustBullet({
  text
}: {
  text: string;
}) {
  return <div className="flex items-center gap-2 text-bg/60 font-body text-sm" data-id="element-734">
      <span className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" aria-hidden="true" data-id="element-735" />
      {text}
    </div>;
}
// ─── Split Selector ──────────────────────────────────────────────────────────
function SplitSelectorSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-bg grid-bg-light" data-id="element-736">
      <div className="max-w-5xl mx-auto" data-id="element-737">
        <div className="text-center mb-14" data-id="element-738">
          <h2 className="font-editorial font-bold text-3xl sm:text-4xl md:text-5xl text-dark mb-4" data-id="element-739">
            Elige tu camino
          </h2>
          <p className="font-body text-dark/60 text-lg max-w-xl mx-auto" data-id="element-740">
            Tenemos un programa diseñado específicamente para tu situación.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-741">
          {/* Agente card */}
          <Link to="/agentes" className="group relative bg-dark rounded-2xl p-8 border border-white/5 hover:border-accent/30 transition-all duration-300 overflow-hidden" data-id="element-742">
            <div className="absolute inset-0 bg-gradient-to-br from-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl" aria-hidden="true" data-id="element-743" />
            <div className="relative z-10" data-id="element-744">
              <div className="inline-block bg-accent/15 text-accent text-xs font-body font-semibold tracking-wider uppercase rounded-full px-3 py-1 mb-5" data-id="element-745">
                6 meses
              </div>
              <h3 className="font-editorial font-bold text-2xl sm:text-3xl text-bg mb-3" data-id="element-746">
                Soy Agente
              </h3>
              <p className="font-body text-bg/55 text-sm mb-6 leading-relaxed" data-id="element-747">
                Construye tu sistema de prospección, ventas y reclutamiento
                desde cero con estructura real.
              </p>
              <ul className="space-y-3 mb-8" data-id="element-748">
                <PathBullet text="Genera tus propios leads digitales" data-id="element-749" />
                <PathBullet text="Sistema de seguimiento y cierre" data-id="element-750" />
                <PathBullet text="Proceso de reclutamiento con estructura" data-id="element-751" />
                <PathBullet text="Acompañamiento semanal" data-id="element-752" />
                <PathBullet text="Deja de depender de referidos" data-id="element-753" />
              </ul>
              <div className="flex items-center gap-2 text-accent font-body font-semibold text-sm group-hover:gap-3 transition-all duration-200" data-id="element-754">
                Ver programa para agentes
                <span aria-hidden="true" data-id="element-755">→</span>
              </div>
            </div>
          </Link>

          {/* Agencia card */}
          <Link to="/duenos-de-agencia" className="group relative bg-dark rounded-2xl p-8 border border-accent/20 hover:border-accent/50 transition-all duration-300 overflow-hidden" data-id="element-756">
            <div className="absolute inset-0 bg-gradient-to-br from-accent/8 to-transparent opacity-100 rounded-2xl" aria-hidden="true" data-id="element-757" />
            <div className="relative z-10" data-id="element-758">
              <div className="inline-flex items-center gap-2 mb-5" data-id="element-759">
                <div className="inline-block bg-accent text-dark text-xs font-body font-semibold tracking-wider uppercase rounded-full px-3 py-1" data-id="element-760">
                  90 días
                </div>
                <div className="inline-block bg-accent/15 text-accent text-xs font-body font-semibold tracking-wider uppercase rounded-full px-3 py-1" data-id="element-761">
                  + Fractional CMO
                </div>
              </div>
              <h3 className="font-editorial font-bold text-2xl sm:text-3xl text-bg mb-3" data-id="element-762">
                Tengo Agencia
              </h3>
              <p className="font-body text-bg/55 text-sm mb-6 leading-relaxed" data-id="element-763">
                Escala tu agencia con marketing digital, reclutamiento
                sistemático y dirección estratégica.
              </p>
              <ul className="space-y-3 mb-8" data-id="element-764">
                <PathBullet text="Estrategia de marketing digital completa" data-id="element-765" />
                <PathBullet text="Sistema de reclutamiento escalable" data-id="element-766" />
                <PathBullet text="Dirección de marketing (Fractional CMO)" data-id="element-767" />
                <PathBullet text="Implementación en 90 días" data-id="element-768" />
                <PathBullet text="Métricas y optimización continua" data-id="element-769" />
              </ul>
              <div className="flex items-center gap-2 text-accent font-body font-semibold text-sm group-hover:gap-3 transition-all duration-200" data-id="element-770">
                Ver programa para agencias
                <span aria-hidden="true" data-id="element-771">→</span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>;
}
function PathBullet({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-2.5 font-body text-sm text-bg/70" data-id="element-772">
      <span className="w-4 h-4 rounded-full border border-accent/40 flex items-center justify-center flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-773">
        <span className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-774" />
      </span>
      {text}
    </li>;
}
// ─── Testimonial Data ────────────────────────────────────────────────────────
type Testimonial = {
  vimeoId: string;
  initials: string;
  name: string;
  role: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  vimeoId: '1165844025',
  initials: 'W',
  name: 'Wanda Ramirez',
  role: 'Regional Leader | Camino Brillante',
  quote: 'Reclutas Digitales eliminó la improvisación en mi proceso de reclutamiento. Pasé de los métodos tradicionales a tener un sistema que me entrega prospectos calificados todos los días. Ahora mi equipo crece con predictibilidad y control.'
}, {
  vimeoId: '1165843949',
  initials: 'M',
  name: 'Marleny Fermin',
  role: 'Regional Leader | Camino Brillante',
  quote: 'Antes dependía de métodos tradicionales para reclutar. Con Reclutas Digitales tengo un sistema que trabaja para mí todos los días, generando prospectos calificados de forma constante. Mi negocio ahora tiene estructura real.'
}];
function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <div className="flex flex-col gap-4 max-w-xs mx-auto w-full" data-id="element-775">
      {/* Video box — portrait 9:16 */}
      {testimonial.vimeoId ? <div className="relative w-full rounded-2xl overflow-hidden shadow-lg shadow-black/40 border border-white/10" style={{
      paddingTop: '177.78%'
    }} data-id="element-776">
          <iframe src={`https://player.vimeo.com/video/${testimonial.vimeoId}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" className="absolute top-0 left-0 w-full h-full" title={`Testimonio ${testimonial.name}`} data-id="element-777" />
        </div> : <div className="relative w-full rounded-2xl overflow-hidden shadow-lg shadow-black/40 border border-white/10 bg-bg/5" style={{
      paddingTop: '177.78%'
    }} data-id="element-778">
          <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-779">
            <div className="w-16 h-16 rounded-full bg-accent/15 border border-accent/30 flex items-center justify-center mb-3" data-id="element-780">
              <svg className="w-7 h-7 text-accent/50" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-781">
                <path d="M8 5v14l11-7z" data-id="element-782" />
              </svg>
            </div>
            <p className="font-body text-bg/30 text-sm" data-id="element-783">Video próximamente</p>
          </div>
        </div>}

      {/* Text card */}
      <div className="bg-bg/5 border border-white/10 rounded-2xl p-6" data-id="element-784">
        {/* Stars */}
        <div className="flex items-center gap-0.5 mb-4 justify-center" data-id="element-785">
          {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-accent" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-786">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-787" />
            </svg>)}
        </div>

        {/* Quote */}
        <blockquote className="font-body text-bg/70 text-sm leading-relaxed text-center mb-5" data-id="element-788">
          "{testimonial.quote}"
        </blockquote>

        {/* Author */}
        <div className="text-center" data-id="element-789">
          <p className="font-body font-semibold text-bg text-sm" data-id="element-790">
            {testimonial.name}
          </p>
          <p className="font-body text-bg/45 text-xs mt-0.5" data-id="element-791">
            {testimonial.role}
          </p>
        </div>
      </div>
    </div>;
}
// ─── Resultados Section ──────────────────────────────────────────────────────
function ResultadosSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-dark" data-id="element-792">
      <div className="max-w-6xl mx-auto" data-id="element-793">
        <div className="text-center mb-14" data-id="element-794">
          <div className="inline-block border border-accent/30 text-accent text-xs tracking-widest uppercase rounded-full px-4 py-1.5 mb-5 font-body" data-id="element-795">
            Resultados
          </div>
          <h2 className="font-editorial font-bold text-3xl sm:text-4xl md:text-5xl text-bg mb-4" data-id="element-796">
            Resultados medibles, sin humo.
          </h2>
          <p className="font-body text-bg/55 text-lg max-w-2xl mx-auto" data-id="element-797">
            Métricas reales de los sistemas que instalamos. Sin promesas de
            ingresos.
          </p>
        </div>

        {/* Metric cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-16" data-id="element-798">
          <MetricCard label="Velocidad de respuesta" value="< 5 min" description="Tiempo promedio de primer contacto con leads" data-id="element-799" />
          <MetricCard label="Contactabilidad" value="+40%" description="Mejora en tasa de contacto con prospectos" data-id="element-800" />
          <MetricCard label="Show rate" value="+60%" description="Asistencia a citas programadas con sistema" data-id="element-801" />
          <MetricCard label="Consistencia de citas" value="Semanal" description="Flujo constante de citas sin depender de referidos" data-id="element-802" />
          <MetricCard label="Seguimiento" value="100%" description="Prospectos con seguimiento estructurado y automatizado" data-id="element-803" />
          <MetricCard label="Reclutamiento con sistema" value="Activo" description="Pipeline de reclutamiento funcionando en paralelo" data-id="element-804" />
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-805">
          {testimonials.map((t, i) => <TestimonialCard key={i} testimonial={t} data-id="element-806" />)}
        </div>

        <div className="mt-8 text-center" data-id="element-807">
          <p className="font-body text-bg/35 text-xs" data-id="element-808">
            * Testimonios individuales. Los resultados varían según el esfuerzo
            y contexto de cada persona.
          </p>
        </div>
      </div>
    </section>;
}
function MetricCard({
  label,
  value,
  description
}: {
  label: string;
  value: string;
  description: string;
}) {
  return <div className="bg-bg/5 border border-white/8 rounded-xl p-6 hover:border-accent/25 transition-colors duration-200" data-id="element-809">
      <p className="font-body text-bg/45 text-xs uppercase tracking-wider mb-2" data-id="element-810">
        {label}
      </p>
      <p className="font-editorial font-bold text-3xl text-accent mb-2" data-id="element-811">
        {value}
      </p>
      <p className="font-body text-bg/55 text-sm leading-relaxed" data-id="element-812">
        {description}
      </p>
    </div>;
}
// ─── Método CONTROL ──────────────────────────────────────────────────────────
function MetodoControlSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-bg grid-bg-light" data-id="element-813">
      <div className="max-w-6xl mx-auto" data-id="element-814">
        <div className="text-center mb-14" data-id="element-815">
          <div className="inline-block border border-accent/40 text-accent text-xs tracking-widest uppercase rounded-full px-4 py-1.5 mb-5 font-body" data-id="element-816">
            Metodología
          </div>
          <h2 className="font-editorial font-bold text-3xl sm:text-4xl md:text-5xl text-dark mb-4" data-id="element-817">
            El método <span className="text-accent" data-id="element-818">CONTROL</span>
          </h2>
          <p className="font-body text-dark/60 text-lg max-w-2xl mx-auto" data-id="element-819">
            Siete pilares que transforman la improvisación en un sistema de
            crecimiento real.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-820">
          <ControlCard letter="C" title="Campaña" description="Diseño y ejecución de campañas digitales para generar leads propios y predecibles, sin depender de referidos." data-id="element-821" />
          <ControlCard letter="O" title="Organización" description="Estructura de procesos, CRM y flujos de trabajo para que nada se pierda y todo tenga seguimiento." data-id="element-822" />
          <ControlCard letter="N" title="Nutrición" description="Secuencias de seguimiento automatizadas y manuales que mantienen el interés del prospecto hasta el cierre." data-id="element-823" />
          <ControlCard letter="T" title="Transformación" description="Proceso de ventas estructurado: desde el primer contacto hasta el cierre, con guiones y metodología probada." data-id="element-824" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-5" data-id="element-825">
          <ControlCard letter="R" title="Reclutamiento" description="Sistema paralelo de atracción de talento para crecer tu equipo con candidatos calificados de forma constante." data-id="element-826" />
          <ControlCard letter="O" title="Optimización" description="Análisis de métricas, pruebas A/B y mejora continua para que el sistema se vuelva más eficiente cada semana." data-id="element-827" />
          <ControlCard letter="L" title="Liderazgo" description="Desarrollo del liderazgo personal y de equipo para sostener el crecimiento con cultura, visión y dirección clara." data-id="element-828" />
        </div>
      </div>
    </section>;
}
function ControlCard({
  letter,
  title,
  description
}: {
  letter: string;
  title: string;
  description: string;
}) {
  return <div className="bg-dark rounded-2xl p-7 border border-white/5 group hover:border-accent/25 transition-all duration-300" data-id="element-829">
      <div className="w-10 h-10 rounded-lg bg-accent/15 flex items-center justify-center mb-5" data-id="element-830">
        <span className="font-editorial font-bold text-accent text-xl" data-id="element-831">
          {letter}
        </span>
      </div>
      <h3 className="font-editorial font-bold text-xl text-bg mb-3" data-id="element-832">{title}</h3>
      <p className="font-body text-bg/55 text-sm leading-relaxed" data-id="element-833">
        {description}
      </p>
    </div>;
}
// ─── Fundadores Section ──────────────────────────────────────────────────────
function FundadoresSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-dark" data-id="element-834">
      <div className="max-w-5xl mx-auto" data-id="element-835">
        <div className="text-center mb-14" data-id="element-836">
          <div className="inline-block border border-accent/30 text-accent text-xs tracking-widest uppercase rounded-full px-4 py-1.5 mb-5 font-body" data-id="element-837">
            Quiénes somos
          </div>
          <h2 className="font-editorial font-bold text-3xl sm:text-4xl md:text-5xl text-bg mb-6" data-id="element-838">
            Los fundadores
          </h2>
          <p className="font-body text-bg/60 text-base sm:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-839">
            Reclutas Digitales fue creado por estrategas que han vivido el
            crecimiento real en la industria de seguros. Este programa nace para
            resolver un problema específico: dejar de improvisar y construir
            crecimiento real con estructura y acompañamiento.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-840">
          {/* Ignacio */}
          <div className="bg-bg/5 border border-white/8 rounded-2xl p-8" data-id="element-841">
            <div className="flex flex-col items-center text-center mb-5" data-id="element-842">
              <div className="w-48 h-48 rounded-full border-2 border-accent/30 flex-shrink-0 overflow-hidden mb-5" data-id="element-843">
                <img src="https://cdn.magicpatterns.com/uploads/xrUKFh9t8dVTX1vUyFbDcC/Untitled_design_(37).png" alt="Ignacio Gerberg" className="w-full h-full object-cover object-top" data-id="element-844" />
              </div>
              <h3 className="font-editorial font-bold text-xl text-bg" data-id="element-845">
                Ignacio Gerberg
              </h3>
              <p className="font-body text-accent text-sm font-medium" data-id="element-846">
                CEO / Co-fundador · Estratega Digital
              </p>
            </div>
            <p className="font-body text-bg/60 text-sm leading-relaxed text-center" data-id="element-847">
              Marketer y estratega digital con más de 10 años de experiencia. Ha
              gestionado millones en publicidad digital y trabajado con IMOs,
              FMOs, agencias y agentes en todo el país, construyendo sistemas de
              crecimiento escalables para la industria de seguros de vida,
              ayudando a generar mas de $10 millones en Ventas.
            </p>
          </div>

          {/* Ángel */}
          <div className="bg-bg/5 border border-white/8 rounded-2xl p-8" data-id="element-848">
            <div className="flex flex-col items-center text-center mb-5" data-id="element-849">
              <div className="w-48 h-48 rounded-full border-2 border-accent/30 flex-shrink-0 overflow-hidden mb-5" data-id="element-850">
                <img src="https://cdn.magicpatterns.com/uploads/dZ7kGynGTbQpT6ryLb8uyA/69a6771c966d7bdea496e5ef_angel_2.jpg" alt="Ángel González" className="w-full h-full object-cover object-top" data-id="element-851" />
              </div>
              <h3 className="font-editorial font-bold text-xl text-bg" data-id="element-852">
                Ángel González
              </h3>
              <p className="font-body text-accent text-sm font-medium" data-id="element-853">
                COO / Co-fundador · Estratega de Marketing
              </p>
            </div>
            <p className="font-body text-bg/60 text-sm leading-relaxed text-center" data-id="element-854">
              Estratega de Marketing Digital y reclutamiento con experiencia
              directa en el campo. Junto a Ignacio, han ayudado a generar más de
              $10 millones en ventas trabajando con agencias y agentes en todo
              el país, desarrollando procesos replicables y sistemas de
              reclutamiento con estructura.
            </p>
          </div>
        </div>

        <div className="bg-accent/10 border border-accent/20 rounded-xl p-5 text-center" data-id="element-855">
          <p className="font-body text-bg/50 text-xs leading-relaxed" data-id="element-856">
            * Los $10 millones en ventas mencionados representan resultados
            históricos de clientes y no garantizan resultados futuros. Los
            resultados individuales varían según el esfuerzo, mercado y contexto
            de cada persona.
          </p>
        </div>
      </div>
    </section>;
}
// ─── Auditoría CTA Section ───────────────────────────────────────────────────
function AuditoriaCTASection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-bg grid-bg-light" data-id="element-857">
      <div className="max-w-4xl mx-auto text-center" data-id="element-858">
        <div className="bg-dark rounded-3xl p-10 sm:p-14 border border-accent/20 relative overflow-hidden" data-id="element-859">
          {/* Subtle glow */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none" aria-hidden="true" data-id="element-860">
            <div className="w-[500px] h-[300px] rounded-full blur-3xl" style={{
            background: 'radial-gradient(ellipse at center, rgba(212,168,67,0.10) 0%, transparent 70%)'
          }} data-id="element-861" />
          </div>
          <div className="relative z-10" data-id="element-862">
            <div className="inline-block border border-accent/40 text-accent text-xs tracking-widest uppercase rounded-full px-4 py-1.5 mb-6 font-body" data-id="element-863">
              Diagnóstico gratuito
            </div>
            <h2 className="font-editorial font-bold text-3xl sm:text-4xl text-bg mb-4 leading-tight" data-id="element-864">
              ¿Tu agencia está diseñada para{' '}
              <span className="text-accent" data-id="element-865">activar reclutas</span> o para
              perderlos?
            </h2>
            <p className="font-body text-bg/60 text-lg mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-866">
              10 preguntas. 3 minutos. Un diagnóstico claro de dónde está la
              falla en tu proceso de reclutamiento y activación.
            </p>
            <Link to="/auditoria" className="inline-flex items-center justify-center bg-accent hover:bg-accent-dark text-dark font-body font-semibold text-base rounded-full px-8 py-4 transition-colors duration-200" data-id="element-867">
              Hacer auditoría express →
            </Link>
            <p className="font-body text-bg/30 text-xs mt-5" data-id="element-868">
              Basado en el Método BTS™ — Build · Track · Scale
            </p>
          </div>
        </div>
      </div>
    </section>;
}
// ─── FAQ Section ─────────────────────────────────────────────────────────────
type FAQItemType = {
  question: string;
  answer: string;
};
const faqItems: FAQItemType[] = [{
  question: '¿Esto es para agentes nuevos o con experiencia?',
  answer: 'El programa está diseñado para ambos perfiles. Si eres nuevo, te damos la estructura desde el inicio para no improvisar. Si ya tienes experiencia, te ayudamos a sistematizar lo que ya haces y escalar con procesos reales.'
}, {
  question: '¿Garantizan resultados de ingresos?',
  answer: 'No. Nunca prometemos ingresos específicos. Lo que garantizamos es la instalación de un sistema: leads, proceso de ventas y reclutamiento. Los resultados dependen del esfuerzo, mercado y contexto de cada persona.'
}, {
  question: '¿Cuánto tiempo requiere el programa?',
  answer: 'El programa para agentes tiene una duración de 6 meses con acompañamiento semanal. El programa para dueños de agencia es de 90 días con implementación intensiva y dirección de marketing (Fractional CMO).'
}, {
  question: '¿Qué diferencia a Reclutas Digitales de otros programas?',
  answer: 'No somos un curso. Somos una incubadora de implementación. No te enseñamos teoría y te dejamos solo — instalamos el sistema contigo, semana a semana, con acompañamiento real y métricas de seguimiento.'
}, {
  question: '¿Cómo empiezo?',
  answer: 'El primer paso es agendar una consultoría sin costo. En esa llamada evaluamos tu situación actual, tus objetivos y si el programa es el fit correcto para ti. Sin presión, sin ventas agresivas.'
}];
function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-bg grid-bg-light" data-id="element-869">
      <div className="max-w-3xl mx-auto" data-id="element-870">
        <div className="text-center mb-14" data-id="element-871">
          <div className="inline-block border border-accent/40 text-accent text-xs tracking-widest uppercase rounded-full px-4 py-1.5 mb-5 font-body" data-id="element-872">
            Preguntas frecuentes
          </div>
          <h2 className="font-editorial font-bold text-3xl sm:text-4xl md:text-5xl text-dark" data-id="element-873">
            Resolvemos tus dudas
          </h2>
        </div>

        <div className="space-y-3" data-id="element-874">
          {faqItems.map((item, index) => <div key={index} className="bg-dark border border-white/8 rounded-xl overflow-hidden" data-id="element-875">
              <button className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left hover:bg-white/[0.03] transition-colors duration-200" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-876">
                <span className="font-body font-semibold text-bg text-sm sm:text-base leading-snug" data-id="element-877">
                  {item.question}
                </span>
                <span className={`flex-shrink-0 w-6 h-6 rounded-full border border-accent/30 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-878">
                  <svg className="w-3 h-3 text-accent" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-879">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" data-id="element-880" />
                  </svg>
                </span>
              </button>
              <div className={`accordion-content ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-881">
                <div className="px-6 pb-5" data-id="element-882">
                  <p className="font-body text-bg/60 text-sm leading-relaxed" data-id="element-883">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
// ─── Final CTA Band ───────────────────────────────────────────────────────────
function FinalCTASection() {
  return <section className="relative py-24 px-4 sm:px-6 lg:px-8 bg-dark overflow-hidden" data-id="element-884">
      {/* Subtle glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" aria-hidden="true" data-id="element-885">
        <div className="w-[600px] h-[300px] rounded-full blur-3xl" style={{
        background: 'radial-gradient(ellipse at center, rgba(176,141,87,0.12) 0%, transparent 70%)'
      }} data-id="element-886" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-887">
        <div className="inline-block border border-accent/30 text-accent text-xs tracking-widest uppercase rounded-full px-4 py-1.5 mb-6 font-body" data-id="element-888">
          Próximo paso
        </div>
        <h2 className="font-editorial font-bold text-3xl sm:text-4xl md:text-5xl text-bg mb-5 leading-tight" data-id="element-889">
          Deja de improvisar.
          <br data-id="element-890" />
          Construye con <span className="text-accent" data-id="element-891">estructura</span>.
        </h2>
        <p className="font-body text-bg/60 text-lg mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-892">
          Agenda una consultoría sin costo. Evaluamos tu situación y te decimos
          si el programa es el fit correcto para ti.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-893">
          <Link to="/contact-us" className="w-full sm:w-auto inline-flex items-center justify-center bg-accent hover:bg-accent-dark text-dark font-body font-semibold text-base rounded-full px-8 py-4 transition-colors duration-200" data-id="element-894">
            Agendar consultoría gratuita
          </Link>
          <Link to="/como-funciona" className="w-full sm:w-auto inline-flex items-center justify-center border border-bg/25 hover:border-bg/50 text-bg font-body font-medium text-base rounded-full px-8 py-4 transition-colors duration-200" data-id="element-895">
            Ver cómo funciona
          </Link>
        </div>
        <p className="font-body text-bg/30 text-xs mt-8" data-id="element-896">
          Sin presión. Sin promesas de ingresos. Solo estructura y
          acompañamiento real.
        </p>
      </div>
    </section>;
}
// ─── Home Page ────────────────────────────────────────────────────────────────
export function HomePage() {
  return <div className="w-full" data-id="element-897">
      <HeroSection data-id="element-898" />
      <SplitSelectorSection data-id="element-899" />
      <ResultadosSection data-id="element-900" />
      <MetodoControlSection data-id="element-901" />
      <FundadoresSection data-id="element-902" />
      <AuditoriaCTASection data-id="element-903" />
      <FAQSection data-id="element-904" />
      <FinalCTASection data-id="element-905" />
    </div>;
}